import { StorageUtil } from "@shared/utils";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

const Redirector = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const siq_project = searchParams.get("siq_project");
  const sc_surveyId = searchParams.get("sc_surveyId");

  useEffect(() => {
    if (siq_project && sc_surveyId) {
      // Use the utility function for setting multiple session items
      StorageUtil.setSessionItems({
        siq_project: siq_project,
        sc_surveyId: sc_surveyId,
        appMode: "surveyBuilderOnly",
      });
      navigate(`/innerapp/${sc_surveyId}/builder`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [siq_project, sc_surveyId, navigate]);

  return <div>Redirector</div>;
};

export default Redirector;
